import { render, staticRenderFns } from "./bannersBottom.vue?vue&type=template&id=0553976c&scoped=true&"
import script from "./bannersBottom.vue?vue&type=script&lang=js&"
export * from "./bannersBottom.vue?vue&type=script&lang=js&"
import style0 from "./bannersBottom.vue?vue&type=style&index=0&id=0553976c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0553976c",
  null
  
)

export default component.exports